import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=358c4d46&scoped=true&"
import script from "./IconEdit.vue?vue&type=script&lang=js&"
export * from "./IconEdit.vue?vue&type=script&lang=js&"
import style0 from "./IconEdit.vue?vue&type=style&index=0&id=358c4d46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c4d46",
  null
  
)

export default component.exports